"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var width = _a.width;
    if (!width) {
        return null;
    }
    if (typeof width === 'object') {
        var _b = width.min, min = _b === void 0 ? '' : _b, _c = width.max, max = _c === void 0 ? '' : _c;
        return "\n      " + (min && "min-width: " + min + ";") + "\n      " + (max && "max-width: " + max + ";") + "\n    ";
    }
    return "width: " + width + ";";
});
